import React from "react";
import { Button, Select, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const TagMultiFilter = ({ value = [], onChange, onSearch, placeholder }) => (
    <div style={{ padding: 8, minWidth: 280 }} dir="rtl">
        <Select
            mode="tags"
            value={value}
            onChange={onChange}
            tokenSeparators={[",", "،"]}
            placeholder={placeholder}
            allowClear
            open={false}
            style={{ width: "100%", marginBottom: 8 }}
            notFoundContent={null}
        />
        <Space>
            <Button
                type="primary"
                onClick={onSearch}
                icon={<SearchOutlined size={16} />}
                size="small"
                className="font-custom"
            >
                جستجو
            </Button>
            <Button
                size="small"
                className="font-custom"
                onClick={() => {
                    onChange([]);
                    onSearch([]);
                }}
                disabled={value.length === 0}
            >
                پاک‌کردن
            </Button>
        </Space>
    </div>
);

export default TagMultiFilter;
